import { render, staticRenderFns } from "./CardPost.vue?vue&type=template&id=8849d8fa&"
import script from "./CardPost.vue?vue&type=script&lang=js&"
export * from "./CardPost.vue?vue&type=script&lang=js&"
import style0 from "./CardPost.vue?vue&type=style&index=0&id=8849d8fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CardPost.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports